import type { Container } from 'pixi.js';

export function hookUpPropsOfOther(target: Container, source: Container): () => void {
  if (target.destroyed || source.destroyed) return () => {};

  const cloneProps = (): void => {
    if (target.destroyed || source.destroyed) return;
    target.pivot = source.pivot;
    target.position = source.position;
    target.scale = source.scale;
    target.alpha = source.alpha;
    target.angle = source.angle;
  };

  target.pixi.ticker.add(cloneProps);
  cloneProps();

  source.on('destroyed', () => {
    if (target.destroyed) return;
    target.destroy();
    source.pixi.ticker.remove(cloneProps);
  });

  return () => source.pixi.ticker.remove(cloneProps);
}
